<template>
  <div class="about">
    <h1>A Vue Practice website</h1>
  </div>
</template>
